function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sort-thin_svg__fil0{fill:#2b2a29;fill-rule:nonzero}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sort-thin_svg__group_1"
}, /*#__PURE__*/React.createElement("g", {
  id: "sort-thin_svg___2099739853280"
}, /*#__PURE__*/React.createElement("path", {
  className: "sort-thin_svg__fil0",
  d: "M0 0h9779v500H0zM0 2718.6h6365.87v500H0zM0 5397.51h3217.32v500H0z"
})));

function SvgSortThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9779 5897.51",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref, _ref2);
}

export default SvgSortThin;